module.exports = __webpack_public_path__ + "static/img/gongsidizhi.25120ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gongsidizhi.png
// module id = mPpW
// module chunks = 6